import styled, { css } from 'styled-components';

import {
    SearchField as DefaultSearchField,
    Typography,
} from '@speeki/global-ui-components';

import { breakpoints } from '@shared/constants';

export const HeaderWrapper = styled.div`
    align-items: center;
    display: flex;
    justify-content: space-between;
    margin-bottom: 40px;

    @media (max-width: ${breakpoints.xs}px) {
        align-items: flex-start;
        flex-direction: column;
    }
`;

export const Title = styled(Typography.TextH2_28_44)(
    ({ theme: { fontWeight } }) => css`
        @media (max-width: ${breakpoints.md}px) {
            font-weight: ${fontWeight.normal};
            line-height: 36px;
            margin-bottom: 24px;
        }
    `,
);

export const SearchField = styled(DefaultSearchField)`
    max-width: 458px;
    width: 100%;

    @media (max-width: ${breakpoints.xs}px) {
        max-width: 100%;
    }
`;
